import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { ScrollArea, View } from "@/components/ui";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { cn } from "@/lib/utils";

import type { BottomDrawerModalProps } from "./type";

export function BottomDrawerModal({
  open,
  onOpenChange,
  children,
  className,
  disableDismiss = false,
}: BottomDrawerModalProps) {
  const { mediaQuery } = useWindowDimensions();

  const preventDismiss = (event: Event) => event.preventDefault();

  // its weird because the drawer onOpenChange is triggered twice
  // then causing the drawer open state is always false if we don't do this handler to prevent double invocation
  const handleOpenChange = (isOpen: boolean) => {
    if (open !== isOpen) {
      onOpenChange?.(isOpen);
    }
  };

  if (mediaQuery === "desktop") {
    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent
          className="bg-white p-0"
          onPointerDownOutside={disableDismiss ? preventDismiss : undefined}
          onInteractOutside={disableDismiss ? preventDismiss : undefined}
          onEscapeKeyDown={disableDismiss ? preventDismiss : undefined}
        >
          <ScrollArea className={cn("max-h-[90vh] p-4", className)}>
            <View className="flex flex-col gap-2">{children}</View>
          </ScrollArea>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      open={open}
      onOpenChange={handleOpenChange}
      direction="bottom"
      dismissible={!disableDismiss}
    >
      <DrawerContent>
        {/* max-height: in mobile web, save some space for navigator */}
        <View className={cn("max-h-[70vh] overflow-auto p-4", className)}>
          <View className="flex flex-col gap-2">{children}</View>
        </View>
      </DrawerContent>
    </Drawer>
  );
}
